import type { TFunction } from "i18next";
import type { DockPageRegistry } from "~/components/dock/dockPageRegistry";

import { ApplicationEnum } from "~/@types/enums";
import createAdminDockPageRegistry from "~admin/dock/adminDockPageRegistry";

export interface DockShellRoute {
	module: ApplicationEnum;
	routePrefix: string;
}

interface RailShellModelEntry {
	prefix: string;
	createModel: (t: TFunction<"common">) => DockPageRegistry;
}

const dockShellRoutes: DockShellRoute[] = [
	{ module: ApplicationEnum.ADMIN, routePrefix: "/settings" },
	{ module: ApplicationEnum.PRODUCE, routePrefix: "/produce" },
	{ module: ApplicationEnum.REPORTS, routePrefix: "/reports" },
	{ module: ApplicationEnum.FULFILL, routePrefix: "/fulfill" },
	{ module: ApplicationEnum.RESTOCK, routePrefix: "/restock" },
	// Forecast dock chrome is gated at runtime by useIsDockShellRoute (tenant Forecast flag).
	{ module: ApplicationEnum.FORECAST, routePrefix: "/forecast" },
	{ module: ApplicationEnum.AVAILABILITY, routePrefix: "/availability" },
	{ module: ApplicationEnum.ENGAGE, routePrefix: "/engage" },
	{ module: ApplicationEnum.MATERIAL, routePrefix: "/material" },
	{ module: ApplicationEnum.VERIFY, routePrefix: "/verify" },
	{ module: ApplicationEnum.EVENTS, routePrefix: "/events" },
	{ module: ApplicationEnum.COUNT, routePrefix: "/count" },
	{ module: ApplicationEnum.INTELLIGENCE, routePrefix: "/intelligence" },
	{ module: ApplicationEnum.BENCHMARK, routePrefix: "/benchmark" }
];

const TITLES_INCLUDE_GATED_PAGES = true;

const railShellModels: RailShellModelEntry[] = [
	{
		createModel: (t) => createAdminDockPageRegistry(t, TITLES_INCLUDE_GATED_PAGES, TITLES_INCLUDE_GATED_PAGES),
		prefix: "/settings"
	}
];

const matchesPrefix = (pathname: string, prefix: string) => pathname === prefix || pathname.startsWith(`${prefix}/`);

export const getDockShellRoute = (pathname: string): DockShellRoute | undefined =>
	dockShellRoutes.find((route) => matchesPrefix(pathname, route.routePrefix));

export const isDockShellPath = (pathname: string): boolean => getDockShellRoute(pathname) !== undefined;

export const resolveRailShellPageTitle = (pathname: string, t: TFunction<"common">): string | undefined => {
	const entry = railShellModels.find(({ prefix }) => matchesPrefix(pathname, prefix));
	return entry?.createModel(t).resolveDockPage(pathname)?.title;
};

export default dockShellRoutes;
